module.exports = __webpack_public_path__ + "img/CM-SL-CA-Volvo-Modern.ff2f6b8d.jpeg";